<template>
    <loading v-if="isLoading || isTranslating" />
    <div class="trip-details" v-else>
        <div class="trip-details-locale" v-if="settings.modules.ai">
            <template v-if="item.hasItemsNeedingTranslation">
                <button
                    class="button is-primary"
                    :class="{ 'is-loading': isTranslating }"
                    :disabled="isTranslating"
                    v-on:click="translateItems"
                >Übersetzen</button>
            </template>
            <template v-else>
                <template v-for="translation in translations">
                    <a v-on:click="switchLocale(translation)">
                        <gb-flag
                            :code="getFlag(translation)"
                            :class="{ 'is-selected' : translation === locale }"
                            size="small"
                            iconPath="/build/img/flags/"
                        />
                    </a>
                </template>
                <simple-menu v-if="locale !== 'de_DE'" material icon="more_vert" title="Menu">
                    <button @click="forceTranslate">Alles neu übersetzen</button>
                </simple-menu>
            </template>
        </div>
        <table-list
            type="provider_info"
            :locale="locale"
            v-on:delete="item => deleteItem('providerTripDetails', item)"
        />
        <box-list
            type="box_map"
            :locale="locale"
            v-on:delete="item => deleteItem('providerTripDetails', item)"
        />
        <box-list
            type="box"
            :locale="locale"
            v-on:delete="item => deleteItem('providerTripDetails', item)"
        />
        <documents
            v-bind:params="params"
            v-bind:uploadData="uploadData"
            :hasFilter="false"
            title="Dokumente für die Reiseunterlagen"
        />
    </div>
</template>

<script>
import { List as BoxList } from './Box';
import { List as TableList } from './Table';
import mixin from '../tab';
import { getProviderTripDetails, translateProviderTripDetails } from '@api'
import Loading from '@components/Loading'
import Documents from "@components/documents/List.vue";
import { getFlag, getTranslationOptions } from '@utilities/functions';
import { settings } from '@clientSpecific/utilities/settings';
import SimpleMenu from '@components/SimpleMenu';

export default {
    mixins: [ mixin ],

    components: {
        Documents,
        BoxList,
        TableList,
        Loading,
        SimpleMenu,
    },

    data() {
        return {
            settings,
            isLoading: false,
            isTranslating: false,
            locale: 'de_DE',
        }
    },

    computed: {
        params: function () {
            return [
                `links.provider.id=${this.item.id}&type=trip_detail`,
            ]
        },
        uploadData: function () {
            return {
                assignment: "order",
                type: "trip_detail",
                links: [{
                    provider: `/api/providers/${this.item.id}`,
                }]
            }
        },
        translations: function () {
            return getTranslationOptions().map(t => t.code);
        },
    },

    methods: {
        getFlag,
        fetchTripDetails: function () {
            this.isLoading = true;
            getProviderTripDetails(
                { 'provider.id': this.item.id, '_groups': ['image_read', 'image_google_map_read', 'info_read'] },
                { headers: { 'X-LOCALE': this.locale } }
            ).then(response => {
                const hasItemsNeedingTranslation = settings.modules.ai && response.data.some(ptd =>
                    ptd.info ? ptd.info.needsTranslation : ptd.needsTranslation
                );
                this.$store.commit('updateData', {
                    providerTripDetails: response.data,
                    hasItemsNeedingTranslation,
                });
            }).then(() => {
                this.isLoading = false;
            });
        },
        switchLocale: function (locale) {
            this.locale = locale;
            this.fetchTripDetails();
        },
        translateItems: function () {
            this.isTranslating = true;
            translateProviderTripDetails(this.item.id).then(() => {
                return this.$store.dispatch('fetchItem', { id: this.item.id });
            }).then(() => {
                return this.fetchTripDetails();
            }).finally(() => {
                this.isTranslating = false;
            });
        },
        forceTranslate: function () {
            this.isTranslating = true;
            translateProviderTripDetails(this.item.id, true).then(() => {
                return this.$store.dispatch('fetchItem', { id: this.item.id });
            }).then(() => {
                return this.fetchTripDetails();
            }).finally(() => {
                this.isTranslating = false;
            });
        },
    },

    activated() {
        this.locale = 'de_DE';
        this.fetchTripDetails();
    }
}
</script>
